import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { SearchStatus } from '../constants';
import { tourAvailabilityRequest } from '../store/slices/tour';

const slotKey = (slot, index) => `${index}|${slot.time}|${slot.description}`;

const useTourSchedule = (productId, details) => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlotKey, setSelectedSlotKey] = useState(null);
  const [pickedMonth, setPickedMonth] = useState(null);
  const searchStartDate = useSelector((store) => store.tripSearch.searchObj?.tour?.startDate);

  const availability = details?.availability;
  const days = availability?.days || [];
  const month = (
    pickedMonth || dayjs(selectedDate || days[0]?.date || searchStartDate || undefined)
  ).startOf('month');
  const monthKey = month.format('YYYY-MM');
  const isLoading = details?.calendarStatus === SearchStatus.SEARCHING;
  const isMonthLoaded = (availability?.months || []).includes(monthKey);
  const hasDaysInMonth = days.some((entry) => (entry.date || '').startsWith(monthKey));
  const isMonthEmpty = !isLoading && !details?.calendarError && isMonthLoaded && !hasDaysInMonth;

  const day = days.find((entry) => entry.date === selectedDate);
  const slots = day?.slots || [];
  const slotIndex = Math.max(
    slots.findIndex((entry, index) => slotKey(entry, index) === selectedSlotKey),
    0,
  );
  const slot = slots[slotIndex];

  const loadMonth = (next, rateQuantities, doReplaceDays = false) =>
    dispatch(
      tourAvailabilityRequest({
        productId,
        date: next.startOf('month').format('YYYY-MM-DD'),
        rateQuantities: Object.keys(rateQuantities || {}).length ? rateQuantities : undefined,
        isCalendar: true,
        doReplaceDays,
      }),
    );

  const selectMonth = (next, rateQuantities) => {
    setPickedMonth(next);
    if ((availability?.months || []).includes(next.format('YYYY-MM'))) {
      return;
    }
    loadMonth(next, rateQuantities);
  };

  const selectDate = (date) => {
    setSelectedDate(date);
    setSelectedSlotKey(null);
    const picked = days.find((entry) => entry.date === date);
    return picked?.slots?.[0];
  };

  const selectSlot = (key) => {
    setSelectedSlotKey(key);
    const picked = slots.find((entry, index) => slotKey(entry, index) === key);
    return picked;
  };

  const reset = () => {
    setSelectedDate(null);
    setSelectedSlotKey(null);
  };

  return {
    days,
    month,
    monthKey,
    selectedDate,
    selectedSlotKey,
    day,
    slot,
    slots,
    slotIndex,
    isLoading,
    isMonthEmpty,
    selectMonth,
    selectDate,
    selectSlot,
    loadMonth,
    reset,
  };
};

export { slotKey };
export default useTourSchedule;
